// generic-client
import PropTypes from 'prop-types';
import cx from 'classnames';

const FooterContainer = function (props) {
  const { className = null } = props;

  const today = new Date();

  return (
    <footer id="footer" className={cx('footer', 'container', className)}>
      <div className="h-100 d-flex flex-column flex-sm-row justify-content-center justify-content-sm-between align-items-start align-items-sm-center">
        <p className="font--xs mb-1 mb-sm-0 text--black">
          © Airtm, Inc. {today.getFullYear()} - v{__APP_VERSION__}
        </p>
      </div>
    </footer>
  );
};

FooterContainer.propTypes = {
  className: PropTypes.string,
};

export default FooterContainer;
